export default __webpack_public_path__ + "static/media/banner-icon2.88da69f4.png";